import React from 'react'

import PropTypes from 'prop-types'

const CLOSE_PATH =
  'M16 1.61143L14.3886 0L8 6.38857L1.61143 0L0 1.61143L6.38857 8' +
  'L0 14.3886L1.61143 16L8 9.61143L14.3886 16L16 14.3886L9.61143 8L16 1.61143Z'

const CloseIcon = ({ fill, className, style, width, height, onClick }) => (
  <svg
    className={className}
    width={width}
    height={height}
    viewBox='0 0 16 16'
    fill='none'
    style={style}
    onClick={onClick}
    xmlns='http://www.w3.org/2000/svg'
  >
    <path d={CLOSE_PATH} fill={fill} />
  </svg>
)

CloseIcon.defaultProps = {
  fill: 'currentColor',
  className: '',
  style: {},
  width: '14',
  height: '14',
  onClick: () => {},
}

CloseIcon.propTypes = {
  fill: PropTypes.string,
  className: PropTypes.string,
  style: PropTypes.object,
  width: PropTypes.string,
  height: PropTypes.string,
  onClick: PropTypes.func,
}

export default CloseIcon
